module.exports = __webpack_public_path__ + "static/media/toolbar-vertical.3e26cbaf.svg";